import * as jQuery from 'jquery';
import $ from 'jquery'
$(function () {

  var $mt = $('.nav__btn_burger');
  var $menu = $('.header__list');

  $(window).on('resize', function () {

    const windowSize = $(window).width();

    if ($menu.css('display') == 'none' && windowSize > 1024) {
      $menu.show();
    }
  });
  $mt.on('click', function () {
    $menu.slideToggle(1000);
  });
});

const links = $('.header__link');

links.on('click', function (e) {
  let href = $(this).attr('href');

  let currentElement = $(href);

  let offset = currentElement.offset().top;

  $('html, body').animate({
    scrollTop: offset
  });
});
jQuery(function () {
  $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').on('click', function () {
    $(this).toggleClass('open');
  });
});
